module.exports = __webpack_public_path__ + "img/sit.654350a4.png";